import { dataType, dataType as types } from '@/constants/data-type';
import { colorBindingTypes as colorTypes, colorValue } from '@/constants/color-binding-type';
import { IPO_STATUS } from '@/constants/ipo-status';
import { formatFunctions } from './formatFunction';
import { utilsFunction } from '@/helpers/functions'
import { store } from '@/configurations'
import { getSafe } from '../../../../helpers/global';
import { IPO_MODE } from '@/constants/app';

export const Converter = {
  mapTradeAccountToOption,
  mapIPOListedFocusData,
  mapAllotmentData,
  mapApplyData,
  mapMarginApplyData,
  mapCAReply,
  mapAssetAllocation,
  mapAccountPL,
  colorMapping,
  mapAccountAsset,
  mappingWebSocketMarket,
  computeQuoteData,
  mappingWebSocketLanguage,
  mappingWinVestLanguage,
  mappingMDSMarketToStock,
  mappingStockCode
}

function mapTradeAccountToOption(rawTradeData) {
  let resultData = rawTradeData.map(traceAccount => {
    return {
      ...traceAccount,
      id: traceAccount.userID,
      value: traceAccount.clientID,
      label: traceAccount.clientID
    }
  });
  return resultData;
}

function mapIPOListedFocusData(rawListedData) {
  let resultData = [];
  if (rawListedData && rawListedData.length > 0) {
    resultData = rawListedData.map(item => {
      let customSymbol = '', customOfferPrice = '';

      customSymbol = `${item.marketID}.${item.instrumentID}`;
      if (item.minOfferPrice && item.maxOfferPrice)
        customOfferPrice = `${item.minOfferPrice} ~ ${item.maxOfferPrice}`;

      return {
        ...item,
        customSymbol: customSymbol,
        customOfferPrice: customOfferPrice
      }
    });
  }
  const arr = resultData.filter(v => v.status !== 'O')
  return arr;
}

function mapAllotmentData(rawData,useIpoAppliedDetailsEnquiryAPI) {
  let allotment = [];
  let totalAmt = 0, status = '';
  let customSymbol = '-', customOfferPrice = '-',stockName = '-';
  let language = store.getState().app.language;
  if(language.lang ==='en_US'){
    stockName = rawData.instrumentName
  }else{
    if(rawData.instrumentChineseName){
      stockName = rawData.instrumentChineseName
    }else{
      stockName = rawData.instrumentName
    }
  }
  if (rawData.marketID && rawData.instrumentID && rawData.instrumentName) {
    customSymbol = `${rawData.marketID}.${rawData.instrumentID} ${stockName}`;
  }

  if (rawData.minOfferPrice && rawData.maxOfferPrice) {
    customOfferPrice = `${formatFunctions.dataFormat(rawData.minOfferPrice, types.CURRENCY)} - ${formatFunctions.dataFormat(rawData.maxOfferPrice, types.CURRENCY)}`;
  }
  if (rawData.status) {
    switch (rawData.status) {
      case IPO_STATUS.OPEN: status = getSafe(() => language.ipo_status_open); break;
      case IPO_STATUS.CONFIRMED_F: status = getSafe(() => language.ipo_status_confirmed); break;
      case IPO_STATUS.CLOSED: status = getSafe(() => language.ipo_status_closed); break;
      case IPO_STATUS.CONFIRMED_D: status = getSafe(() => language.ipo_status_confirmed); break;
      case IPO_STATUS.ACCEPTED_H: status = getSafe(() => language.ipo_status_accepted); break;
      case IPO_STATUS.ACCEPTED_I: status = getSafe(() => language.ipo_status_accepted); break;
      case IPO_STATUS.ACCEPTED_W: status = getSafe(() => language.ipo_status_accepted); break;
      case IPO_STATUS.CANCELLED: status = getSafe(() => language.ipo_status_cancelled); break;
    }

  }
  const dateFormat = (date) => {
    return date.replace(/\//g, '').replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1')
  }
  if(useIpoAppliedDetailsEnquiryAPI){
    let marginFinancingType = '', financingPlanType ='';
    if(rawData.marginFinancingType){
      switch(rawData.marginFinancingType){
        case 'O': marginFinancingType = getSafe(() => language.ipo_own_lending); break;
        case 'E': marginFinancingType = getSafe(() => language.ipo_external_lending); break;
        case 'Z': marginFinancingType = getSafe(() => language.ipo_zero_lending); break;
      }
    }
    if(rawData.financingPlanType){
      switch(rawData.financingPlanType){
        case 'F': financingPlanType = getSafe(() => language.ipo_fixed_Plan); break;
        case 'I': financingPlanType = getSafe(() => language.ipo_interest_plan); break;
      }
    }
    allotment = [
      { label: 'common_symbol_name', value: customSymbol },
      { label: 'common_offer_price', value: customOfferPrice },
      { label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
      { label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
      { label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
      { label: 'financing_plan_type', value:  '-' },
      { label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-'  },
      { label: 'applied_amount', value: rawData.appliedAmount ? formatFunctions.dataFormat(rawData.appliedAmount, types.CASH) : '-' },
      { label: 'handling_fee', value: rawData.handlingFee ? formatFunctions.dataFormat(rawData.handlingFee, types.CASH) : '-' },
      { label: 'ipo_facility_fee', value: rawData.financingFee ? formatFunctions.dataFormat(rawData.financingFee, types.CASH) : '-' },
      { label: 'interest_rate', value: rawData.interestRate ? formatFunctions.dataFormat(rawData.interestRate, types.CASH) : '-' },
      { label: 'interest_amount', value: rawData.interestAmount ? formatFunctions.dataFormat(rawData.interestAmount, types.CASH) : '-' },
      { label: 'loan_amount', value: rawData.appliedLendingAmount ? formatFunctions.dataFormat(rawData.appliedLendingAmount, types.CASH) : '-' },
      { label: 'ipo_event_status', value: rawData.status ? status : '-' },
      { label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
      { label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
      { label: 'ipo_closing_date', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}`},
      rawData.marginFinancingType !=='Z' && { label: 'ipo_drawdown_date', value: rawData.drawdownDate ? dateFormat(rawData.drawdownDate) : '-' },
      rawData.marginFinancingType !=='Z' && { label: 'ipo_repayment_date', value: rawData.repaymentDate ? dateFormat(rawData.repaymentDate) : '-'  },
      rawData.marginFinancingType !=='Z' && { label: 'ipo_deposit_amount', value: rawData.depositAmount ? formatFunctions.dataFormat(rawData.depositAmount, types.CASH) : '-' },
    ];
    totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat((rawData.totalAmount + rawData.handlingFee + rawData.financingFee ), types.CASH)  ;
  }else{
    allotment = [
      { label: 'common_symbol_name', value: customSymbol },
      { label: 'common_offer_price', value: customOfferPrice },
      { label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
      { label: 'application_date', value: rawData.inputDate ? rawData.inputDate : '-' },
      // { label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
      // { label: 'common_status', value: rawData.status ? status : '-' },
      { label: 'applied_qty', value: rawData.appliedQty ? formatFunctions.dataFormat(rawData.appliedQty, types.NUMBER) : '-' },
      { label: 'alloted_qty', value: rawData.allotedQty ? formatFunctions.dataFormat(rawData.allotedQty, types.NUMBER) : '-' },
      // { label: 'confirmed_qty', value: rawData.confirmedQty ? formatFunctions.dataFormat(rawData.confirmedQty, types.NUMBER) : '-' },
      { label: 'confirmed_price', value: rawData.confirmedPrice ? formatFunctions.dataFormat(rawData.confirmedPrice, types.CURRENCY) : '-' },
      // { label: 'confirmed_alloted_date', value: rawData.confirmedAllotmentDate ? rawData.confirmedAllotmentDate : '-' },
      { label: 'alloted_date', value: rawData.allotedDate ? rawData.allotedDate : '-' },
      { label: 'applied_consideration', value: rawData.appliedConsideration ? formatFunctions.dataFormat(rawData.appliedConsideration, types.CASH) : '-' },
      { label: 'handling_fee', value: rawData.handlingFee ? formatFunctions.dataFormat(rawData.handlingFee, types.CASH) : '-' },
      { label: 'loan_amount', value: rawData.appliedLendingAmount ? formatFunctions.dataFormat(rawData.appliedLendingAmount, types.CASH) : '-' },
      { label: 'interest_rate', value: rawData.interestRate ? formatFunctions.dataFormat(rawData.interestRate, types.CASH) : '-' },
      { label: 'ipo_facility_fee', value: rawData.financingFee ? formatFunctions.dataFormat(rawData.financingFee, types.CASH) : '-' },
      { label: 'common_total_amount_of_payment', value: rawData.totalAmount ? formatFunctions.dataFormat(rawData.totalAmount, types.CASH) : '-' },
      // { label: 'applied_fee_amount', value: rawData.appliedFeeAmount ? formatFunctions.dataFormat(rawData.appliedFeeAmount, types.CASH) : '-' },
      // { label: 'allotment_fee', value: rawData.allotmentFee ? formatFunctions.dataFormat(rawData.allotmentFee, types.CASH) : '-' },
      { label: 'refund_amount', value: rawData.refund ? formatFunctions.dataFormat(rawData.refund, types.CASH) : '-' },
      // { label: 'bank_number', value: rawData.bankacID ? rawData.bankacID : '-' },
      { label: 'ipo_event_status', value: rawData.status ? status : '-' },
      { label: 'common_reference_no', value: rawData.subscriptionID ? rawData.subscriptionID : '-' },
      { label: 'interest_amount', value: rawData.interestAmount ? formatFunctions.dataFormat(rawData.interestAmount, types.CASH) : '-' },
      { label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
      { label: 'ipo_closing_date', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}`},
      rawData.marginFinancingType !=='Z' && { label: 'ipo_drawdown_date', value: rawData.drawdownDate ? dateFormat(rawData.drawdownDate) : '-' },
      rawData.marginFinancingType !=='Z' && { label: 'ipo_repayment_date', value: rawData.repaymentDate ? dateFormat(rawData.repaymentDate) : '-'  },
      rawData.marginFinancingType !=='Z' && { label: 'ipo_deposit_amount', value: rawData.depositAmount ? formatFunctions.dataFormat(rawData.depositAmount, types.CASH) : '-' },
    ];
    totalAmt = (rawData.currencyID ? rawData.currencyID : '') + ' ' + formatFunctions.dataFormat((rawData.totalAmount + rawData.handlingFee + rawData.facilityFee) , types.CASH);
  }

  return {
    allotment: allotment,
    totalAmt: totalAmt
  }
}


function mapApplyData(rawData, priceRowData, resultData, language, mode = IPO_MODE.APPLY_ACTION, MarginPreviewData ='') {
  const { clientID } = store.getState().trade.currentTradingAccount
  const tradingAccountName = store.getState().auth.user.external.fullname
  let totalAmt = 0;
  let detailData = [], priceData = [], previewData = [], lotSpreadList = [], stepsData = [], resultResData = [], marginResultData =[], lendingPercentList = [], marginLotSpreadList = [];
  let customSymbol = '-', customSymbol2 = '-', offPrice = '-', endDateTime = '- -', endOnlineDate = '- -', symbolName = '-';
  if(language){
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      symbolName = rawData.instrumentChineseShortName
    }else{
      symbolName = rawData.instrumentShortname
    }
  }
  if (rawData.marketID && rawData.instrumentID) {
    customSymbol = `${rawData.marketID}.${rawData.instrumentID}`;
  }
  if (rawData.marketID && rawData.instrumentID && rawData.instrumentShortname) {
    customSymbol2 = `${rawData.marketID}.${rawData.instrumentID} ${symbolName ? symbolName : rawData.instrumentShortname}`;
  }
  if (rawData.minOfferPrice && rawData.maxOfferPrice) {
    offPrice = `${utilsFunction.currencyFormatter(rawData.minOfferPrice)} - ${utilsFunction.currencyFormatter(rawData.maxOfferPrice)}`
  }
  if (rawData.endDate && rawData.endTime) {
    endDateTime = `${rawData.endDate} ${rawData.endTime}`
  }
  if (rawData.eipoendDate && rawData.eipoendTime) {
    endOnlineDate = `${rawData.eipoendDate} ${rawData.eipoendTime}`
  }

  const dateFormat = (date) => {
    return date.replace(/\//g, '').replace(/^(\d{2})(\d{2})(\d{4})$/, '$3-$2-$1')
  }

  detailData = [
    { label: 'common_symbol', value: customSymbol },
    { label: 'common_name', value: rawData.instrumentShortname ? rawData.instrumentShortname : '-' },
    { label: 'common_number_offer_shares', value: formatFunctions.dataFormat(rawData.numberOfferShares, types.NUMBER) },
    { label: 'common_number_public_offer_shares', value: formatFunctions.dataFormat(rawData.numberPublicOfferShares, types.NUMBER) },
    { label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
    { label: 'common_offer_price_two', value: offPrice ? offPrice : '-' },
    { label: 'common_lot_size', value: rawData.lotSize ? utilsFunction.currencyFormatter(rawData.lotSize, 0) : '-' },
    { label: 'common_start_date_for_application', value: rawData.startDate ? dateFormat(rawData.startDate) : '-' },
    { label: 'common_end_time_for_application', value: `${dateFormat(rawData.endDate)} ${rawData.endTime}` },
    { label: 'common_allotment_date', value: rawData.allotmentDate ? dateFormat(rawData.allotmentDate) : '-' },
    { label: 'common_end_time_for_online_application', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}` },
    { label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
    { label: 'common_listed_exchange', value: rawData.marketID ? rawData.marketID : '-' }
  ]

  stepsData = [
    { id: 0, label: 'ipo_apply_detail_start', time: dateFormat(rawData.startDate) },
    { id: 1, label: 'ipo_apply_detail_close', time: dateFormat(rawData.endDate) },
    { id: 2, label: 'ipo_apply_detail_result', time: dateFormat(rawData.allotmentDate) },
    { id: 3, label: 'ipo_apply_detail_list', time: dateFormat(rawData.listingDate) }
  ]

  priceData = [
    { label: 'common_investment_account_no', value: clientID },
    { label: 'common_investment_account_name', value: tradingAccountName ? tradingAccountName : '-' },
    { label: 'common_symbol_name', value: customSymbol2 },
    { label: 'common_currency', value: rawData.currencyID },
    { label: 'common_offer_price_two', value: offPrice },
    { label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
    { label: 'ipo_closing_date', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}`},
  ]


  lendingPercentList = rawData.lendingPercentList.map(value => {
    let obj = {};
    obj.value = value.leadingPercentage;
    obj.label = value.leadingPercentage;
    return obj
  })

  marginLotSpreadList = rawData.lotSpreadList.map(value => {
    let obj = {};
    obj.value = value.appliedQty;
    obj.label = utilsFunction.currencyFormatter(value.appliedQty, 0);
    obj.overrideAmount = value.overrideAmount;
    return obj
  })

  if (priceRowData) {
    if(mode === IPO_MODE.MARGIN_APPLY_ACTION){
      priceRowData.map(item=>{
        if(item.label === 'ipo_service_charge'){
          item.value = MarginPreviewData.handlingFee ? formatFunctions.dataFormat(MarginPreviewData.handlingFee, types.CASH)  : item.value 
        }
        if(item.label === 'ipo_facility_fee'){
          item.value = MarginPreviewData.facilityFee ? formatFunctions.dataFormat(MarginPreviewData.facilityFee, types.CASH)   : item.value 
        }
        return item
      })
    }
    previewData = [
      { label: 'common_investment_account_no', value: clientID },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_customer_name', value: getSafe(() => language.ipo_customer_value)},
      { label: 'common_symbol_name', value: customSymbol2 },
      { label: 'common_currency', value: rawData.currencyID },
      { label: 'common_offer_price_two', value: offPrice },
      { label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
      { label: 'common_application_time', value: rawData.inputTime ? rawData.inputTime : '-' },
      { label: 'common_allotment_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
      { label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
      { label: 'ipo_closing_date', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}`},
      ...priceRowData,
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_loan_interest', value: MarginPreviewData.interestAmount ? formatFunctions.dataFormat(MarginPreviewData.interestAmount, types.CASH): '-' },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_settlemnt_account', value: MarginPreviewData.bankacID ? MarginPreviewData.bankacID : '-' },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_custormer_id', value: getSafe(() => language.ipo_customer_value)},
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_correspondence_address', value: getSafe(() => language.ipo_customer_value) },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_contact_phone', value: getSafe(() => language.ipo_customer_value) },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_drawdown_date', value: MarginPreviewData.drawdownDate ? dateFormat(MarginPreviewData.drawdownDate) : '-' },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_repayment_date', value: MarginPreviewData.repaymentDate ? dateFormat(MarginPreviewData.repaymentDate) : '-'  },
      mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_deposit_amount', value: MarginPreviewData.depositAmount ? formatFunctions.dataFormat(MarginPreviewData.depositAmount, types.CASH) : '-' },
    ]

    if (resultData) {
      if(priceRowData){
        priceRowData.map(item=>{
          if(item.label === 'ipo_interest_rate'){
            item.value = resultData.overrideInterestRate ? (formatFunctions.dataFormat(resultData.overrideInterestRate, types.CASH)  + '%') : item.value 
          }
          if(item.label === 'ipo_service_charge'){
            item.value = resultData.handlingFee ? formatFunctions.dataFormat(resultData.handlingFee, types.CASH)  : item.value 
          }
          if(item.label === 'ipo_facility_fee'){
            item.value = resultData.facilityFee ? formatFunctions.dataFormat(resultData.facilityFee, types.CASH)   : item.value 
          }
          return item
        })
      }
      resultResData = [
        { label: 'common_investment_account_no', value: clientID },
        mode === IPO_MODE.MARGIN_APPLY_ACTION && { label: 'ipo_customer_name', value: getSafe(() => language.ipo_customer_value)},
        { label: 'common_symbol_name', value: customSymbol2 },
        { label: 'common_currency', value: rawData.currencyID ? rawData.currencyID : '-' },
        { label: 'common_offer_price_two', value: offPrice },
        { label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) },
        { label: 'common_subscription_no', value: resultData.subscriptionID ? resultData.subscriptionID : '-' },
        { label: 'common_application_time', value: resultData.inputTime ? resultData.inputTime : '-' },
        { label: 'common_allotment_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
        { label: 'common_listing_date', value: rawData.listingDate ? dateFormat(rawData.listingDate) : '-' },
        { label: 'ipo_closing_date', value: `${dateFormat(rawData.eipoendDate)} ${rawData.eipoendTime}`},
        ...priceRowData,
      ],
      marginResultData = [
        // { label: 'ipo_interest_rate', value: resultData.overrideInterestRate ? (formatFunctions.dataFormat(resultData.overrideInterestRate, types.CASH)  + '%') : '-' },
        { label: 'ipo_loan_interest', value: resultData.interestAmount ? formatFunctions.dataFormat(resultData.interestAmount, types.CASH): '-' },
        { label: 'ipo_settlemnt_account', value: resultData.bankACID ? resultData.bankACID : '-' },
        { label: 'ipo_custormer_id', value: getSafe(() => language.ipo_customer_value)},
        { label: 'ipo_correspondence_address', value: getSafe(() => language.ipo_customer_value) },
        { label: 'ipo_contact_phone', value: getSafe(() => language.ipo_customer_value) },
        { label: 'ipo_drawdown_date', value: resultData.drawdownDate ? dateFormat(resultData.drawdownDate) : '-' },
        { label: 'ipo_repayment_date', value: resultData.repaymentDate ? dateFormat(resultData.repaymentDate) : '-'  },
        { label: 'ipo_deposit_amount', value: resultData.depositAmount ? formatFunctions.dataFormat(resultData.depositAmount, types.CASH) : '-' },
      ]
    }

  }


  lotSpreadList = rawData.lotSpreadList.map(item => {
    let data = {
      ...item,
      value: item.appliedQty,
      label: utilsFunction.currencyFormatter(item.appliedQty, 0),
      fee: rawData.handlingFee,
      remark: rawData.remark
    }
    return data
  })
  return {
    detailData: detailData,
    stepsData: stepsData,
    priceData: priceData,
    lotSpreadList: lotSpreadList,
    previewData: previewData,
    resultData: resultResData,
    marginResultData:marginResultData,
    lendingPercentList: lendingPercentList,
    marginLotSpreadList: marginLotSpreadList
  }
}

function mapMarginApplyData(rawData,language) {
  const { tradingAccountName, clientID,tradingAccountID } = store.getState().trade.currentTradingAccount;
  let marginTopData = [];
  let customSymbol = '-', offPrice = '-'
  let symbolName = '-'

  if(language){
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      symbolName = rawData.instrumentChineseShortName
    }else{
      symbolName = rawData.instrumentShortname
    }
  }
  if (rawData.marketID && rawData.instrumentID && rawData.instrumentShortname) {
    customSymbol = `${rawData.marketID}.${rawData.instrumentID} ${symbolName}`;
  }

  if (rawData.minOfferPrice && rawData.maxOfferPrice) {
    offPrice = `${utilsFunction.currencyFormatter(rawData.minOfferPrice)} - ${utilsFunction.currencyFormatter(rawData.maxOfferPrice)}`
  }

  marginTopData = [
    { label: 'common_investment_account_no', value: clientID },
    { label: 'common_symbol_name', value: customSymbol },
    { label: 'common_currency', value: rawData.currencyID },
    { label: 'common_offer_price_two', value: offPrice },
    { label: 'common_lot_size', value: utilsFunction.currencyFormatter(rawData.lotSize, 0) }
  ]

  return marginTopData
}

function mapCAReply(rawData = {}) {
  let caReplyLeftData = [], caReplyRightData = [], caConfirmLeftData = [], caConfirmRightData = [], caResultLeftData = [], caResultRightData = [];
  let customSymbol = '-'
  let subscription = rawData.subscription || {};

  if (rawData && rawData.marketID && rawData.instrumentID) {
    customSymbol = `${rawData.marketID}.${rawData.instrumentID}`;
  }

  caReplyLeftData = [
    { label: 'common_market', value: rawData.marketID ? rawData.marketID : '-' },
    { label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
    { label: 'common_stock_name', value: rawData.instrumentShortName ? rawData.instrumentShortName : '-' },
    { label: 'common_event', value: rawData.eventID ? rawData.eventID : '-' },
    { label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.bookClosedate : '-' },
    { label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.issueInstrumentID : '-' },
    { label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.issueInstrumentShortName : '-' },
  ]
  caReplyRightData = [
    { label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
    { label: 'common_offer_price', value: rawData.offerContent ? rawData.offerContent : '-' },
    { label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
    { label: 'ca_expiry_date', value: rawData.expiryDate ? rawData.expiryDate : '-' },
    { label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
    { label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
    { label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
  ]
  caConfirmLeftData = [
    { label: 'common_market', value: customSymbol },
    { label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
    { label: 'common_stock_name', value: rawData.instrumentName ? rawData.instrumentName : '-' },
    { label: 'common_event', value: rawData.eventID ? rawData.eventID : '-' },
    { label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.bookClosedate : '-' },
    { label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.issueInstrumentID : '-' },
    { label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.issueInstrumentShortName : '-' },
    { label: 'common_offer_price', value: rawData.offerContent ? rawData.offerContent : '-' },
    { label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
    { label: 'ca_expiry_date', value: rawData.expiryDate ? rawData.expiryDate : '-' }
  ]
  caConfirmRightData = [
    { label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
    { label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
    { label: 'ca_exercise_qty', value: rawData.exercisableQty ? rawData.exercisableQty : '-' },
    { label: 'ca_excess_quantity', value: subscription.excessQty ? subscription.excessQty : '-' },
    { label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
    { label: 'ca_dividend_delivery', value: rawData.dividendDelivery ? rawData.dividendDelivery : '-' },
    { label: 'ca_reinvest_quantity', value: subscription.reinvestQty ? subscription.reinvestQty : '-' },
    { label: 'common_handing_fee', value: subscription.handlingFee ? subscription.handlingFee : '-' },
    { label: 'ca_application_amount', value: subscription.applicationAmount ? subscription.applicationAmount : '-' },
    { label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
  ]

  caResultLeftData = [
    { label: 'common_market', value: customSymbol },
    { label: 'common_stock_code', value: rawData.instrumentID ? rawData.instrumentID : '-' },
    { label: 'common_stock_name', value: rawData.instrumentName ? rawData.instrumentName : '-' },
    { label: 'common_event', value: rawData.eventID ? rawData.instrumentID : '-' },
    { label: 'ca_book_close_date', value: rawData.bookClosedate ? rawData.instrumentID : '-' },
    { label: 'ca_issue_instrument_id', value: rawData.issueInstrumentID ? rawData.instrumentID : '-' },
    { label: 'ca_issue_instrument_name', value: rawData.issueInstrumentShortName ? rawData.instrumentID : '-' },
    { label: 'common_offer_price', value: rawData.offerContent ? rawData.instrumentID : '-' },
    { label: 'ca_exercisable_qty', value: rawData.exercisableQty ? rawData.instrumentID : '-' },
  ]


  caResultRightData = [
    { label: 'ca_final_trade_date', value: rawData.finalTradedate ? rawData.finalTradedate : '-' },
    { label: 'ca_channel_cut_off_time', value: rawData.channelCutofftime ? rawData.channelCutofftime : '-' },
    { label: 'ca_book_close_qty', value: rawData.bookCloseQty ? rawData.bookCloseQty : '-' },
    { label: 'ca_dividend_delivery', value: rawData.dividendDelivery ? rawData.dividendDelivery : '-' },
    { label: 'ca_reinvest_quantity', value: subscription.reinvestQty ? subscription.reinvestQty : '-' },
    { label: 'common_handing_fee', value: subscription.handlingFee ? subscription.handlingFee : '-' },
    { label: 'ca_application_amount', value: subscription.applicationAmount ? subscription.applicationAmount : '-' },
    { label: 'common_remark', value: rawData.webRemark ? rawData.webRemark : '-' },
    { label: 'ca_last_update_time', value: subscription.transactionTime ? subscription.transactionTime : '-' },
  ]

  return {
    caReplyLeftData: caReplyLeftData,
    caReplyRightData: caReplyRightData,
    caConfirmLeftData: caConfirmLeftData,
    caConfirmRightData: caConfirmRightData,
    caResultLeftData: caResultLeftData,
    caResultRightData: caResultRightData
  }
}

function mapAssetAllocation(rawData) {
  let assetAllocation = {};

  assetAllocation = {
    ccy: rawData.currencyID ? rawData.currencyID : '-',
    value: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    marketValue: rawData.marketValue ? formatFunctions.dataFormat(rawData.marketValue, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    buyingPower: rawData.buyingPower ? formatFunctions.dataFormat(rawData.buyingPower, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    holdAmount: rawData.holdAmount ? formatFunctions.dataFormat(rawData.holdAmount, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    marginValue: rawData.marginValue ? formatFunctions.dataFormat(rawData.marginValue, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    todayConfirmBuy: rawData.todayConfirmBuy ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    pendingBal: rawData.pendingBalance ? formatFunctions.dataFormat(rawData.pendingBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    withdrawableBal: rawData.withdrawableBalance ? formatFunctions.dataFormat(rawData.withdrawableBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    settledBalance: rawData.settledBalance ? formatFunctions.dataFormat(rawData.settledBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    ledgerBal: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    todayConfirmSell: rawData.todayConfirmSell ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CASH) : formatFunctions.dataFormat(0, types.CASH)
  }

  return assetAllocation;
}

function mapAccountPL(rawData) {
  let accountPL = {};

  accountPL = {
    floatingPL: rawData.totalFloatingPL ? formatFunctions.dataFormat(rawData.totalFloatingPL, types.CASH) : formatFunctions.dataFormat(0, types.CASH),
    floatingPLPercent: rawData.totalFloatingPLPercent ? formatFunctions.dataFormat(rawData.totalFloatingPLPercent, types.PERCENT) : formatFunctions.dataFormat(0, types.PERCENT)
  }

  return accountPL;
}

function mapAccountAsset(rawData) {
  let leftAsset = [], rightAsset = [], SCBLeftAsset = [], SCBRightAsset = [], shortSellValueF = '-';
  if(rawData.shortSellValueF){
    if(rawData.currencyID === 'CNY' || rawData.currencyID === 'USD'){
      shortSellValueF = 'N/A'
    }else{
      shortSellValueF = formatFunctions.dataFormat(rawData.shortSellValueF, types.CASH)
    }
  }

  leftAsset = [
    { label: 'current_account_market_value', value: rawData.marketValue ? formatFunctions.dataFormat(rawData.marketValue, types.CASH) : '-', textColor: '#1996E3' },
    { label: 'current_account_buying_power', value: rawData.buyingPower ? formatFunctions.dataFormat(rawData.buyingPower, types.CASH) : '-', textColor: '#E64033' },
    { label: 'current_account_hold_amount', value: rawData.holdAmount ? formatFunctions.dataFormat(rawData.holdAmount, types.CASH) : '-', textColor: '#FFAD4D' },
    { label: 'current_account_margin_Value', value: rawData.marginValue ? formatFunctions.dataFormat(rawData.marginValue, types.CASH) : '-', textColor: '' },
    { label: 'current_account_today_confirm_buy', value: rawData.todayConfirmBuy ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CASH) : '-', textColor: '' },
  ]

  rightAsset = [
    { label: 'current_account_pending_balance', value: rawData.pendingBalance ? formatFunctions.dataFormat(rawData.pendingBalance, types.CASH) : '-' },
    { label: 'current_account_withdrawable_balance', value: rawData.withdrawableBalance ? formatFunctions.dataFormat(rawData.withdrawableBalance, types.CASH) : '-' },
    { label: 'current_account_settled_balance', value: rawData.settledBalance ? formatFunctions.dataFormat(rawData.settledBalance, types.CASH) : '-' },
    { label: 'current_account_ledger_balance', value: rawData.ledgerBalance ? formatFunctions.dataFormat(rawData.ledgerBalance, types.CASH) : '-' },
    { label: 'current_account_today_confirm_sell', value: rawData.todayConfirmSell ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CASH) : '-' },
  ]

  SCBLeftAsset = [
    { label: 'current_account_pending_settlement', value: utilsFunction.isNull(rawData.pendingSettlement)  ? formatFunctions.dataFormat(rawData.pendingSettlement, types.CASH) : '-' },
    { label: 'current_account_today_confirm_buy', value: utilsFunction.isNull(rawData.todayConfirmBuy) ? formatFunctions.dataFormat(rawData.todayConfirmBuy, types.CASH) : '-' },
    { label: 'current_account_today_confirm_sell', value: utilsFunction.isNull(rawData.todayConfirmSell) ? formatFunctions.dataFormat(rawData.todayConfirmSell, types.CASH) : '-' },
  ]

  SCBRightAsset = [
    { label: 'current_account_outstanding_buy_order', value: utilsFunction.isNull(rawData.osBuyAmt) ? formatFunctions.dataFormat(rawData.osBuyAmt, types.CASH) : '-' },
    { label: 'current_account_market_Value_of_physical_stock_sales', value: shortSellValueF },
    { label: 'current_account_total_purchasing_power', value: utilsFunction.isNull(rawData.usable) ? formatFunctions.dataFormat(rawData.usable, types.CASH) : '-' },
  ]


  return {
    leftAsset,
    rightAsset,
    SCBLeftAsset,
    SCBRightAsset
  }
}

function colorMapping(type, fieldValue) {
  let isPositiveValue = true;
  if (fieldValue) {
    isPositiveValue = Number(fieldValue) > 0;
  }
  switch (type) {
    case colorTypes.MARGIN:
      return {
        color: colorValue.MARGIN
      }
    case colorTypes.BUYING_POWER:
      return {
        color: colorValue.BUYING_POWER
      }
    case colorTypes.HOLD_AMOUNT:
      return {
        color: colorValue.HOLD_AMOUNT
      }
    case colorTypes.UP_DOWN:
      return {
        color: isPositiveValue ? colorValue.UP : colorValue.DOWN
      }
    default: break;
  }
}

function mappingWebSocketMarket(market) {
  switch (market) {
    case "HKEX": return "HK";
    case "MAMK": return "MA";
    case "SZMK": return "SZ";
    case "USEX": return "US";
    default: return market;
  }
}

function mappingWebSocketLanguage(lang) {
  switch (lang) {
    case "ZH_CN": return "sc";
    case "zh_TW": return "tc";
    case "en_US": return "en";
    default: return '';
  }
}

function mappingWinVestLanguage(lang) {
  switch (lang) {
    case "zh_CN": return "zh-hans";
    case "zh_TW": return "zh-hant";
    case "en_US": return "en";
    case "zh-hans": return "hans";
    case "zh-hant": return "hant";
    default: return lang;
  }
}

function computeQuoteData(quote) {
  let change = quote.last - quote.prev;
  const positiveSign = change > 0 ? '+' : '';
  const classStyle = change > 0 ? 'rise-color' : (change < 0 ? 'fall-color' : 'default-color');
  let changePer = (change / quote.prev) * 100;
  change = formatFunctions.dataFormat(change, dataType.CURRENCY);
  changePer = formatFunctions.dataFormat(changePer, dataType.CURRENCY);
  const quoteData = {
    last: formatFunctions.dataFormat(quote.last, dataType.CURRENCY),
    changeValue: `${positiveSign}${change}`,
    changePercent: `(${positiveSign}${changePer}%)`,
    classStyle
  };
  return quoteData;
}

function mappingMDSMarketToStock(market) {
  switch (market) {
    case "HK": return "HKEX";
    case "MA": return "MAMK";
    case "SZ": return "SZMK";
    case "US": return "USEX";
    default: return market;
  }
}

function mappingStockCode(stockCode) {
  if (!stockCode) return;
  let stockID = stockCode.split('').findIndex(i => i !== '0')
  if (stockID > -1) {
    stockID = stockCode.substr(stockID)
  }
  return stockID;
}